exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tag {\n  display: inline;\n}\n#tag a {\n  border: 1px solid #dedede;\n  display: inline;\n  list-style: none;\n  padding: 2px 6px;\n  margin-right: 5px;\n  text-align: center;\n  font-size: 12px;\n  color: #1c1c1c;\n  text-transform: capitalize;\n}\n#tag a:hover {\n  background-color: #000;\n  color: #fff;\n}", ""]);

// exports
